/************************ Project - Natours */
import img1Medicopter from "../assets/project-medicopter/img1.png";
import img2Medicopter from "../assets/project-medicopter/img2.png";
import img3Medicopter from "../assets/project-medicopter/img3.png";
import img4Medicopter from "../assets/project-medicopter/img4.png";
import img5Medicopter from "../assets/project-medicopter/img5.png";
import img6Medicopter from "../assets/project-medicopter/img6.png";
import img7Medicopter from "../assets/project-medicopter/img7.jpeg";
/************************ Project - FikrTeam */
import img1FikrTeam from "../assets/project-fikrteam/img1.png";
import img2FikrTeam from "../assets/project-fikrteam/img2.png";
import img3FikrTeam from "../assets/project-fikrteam/img3.png";
import img4FikrTeam from "../assets/project-fikrteam/img4.png";
/************************ Project - FinGenius AI */
import img1FinGenius from "../assets/project-finGenius-ai/img1.png";
import img2FinGenius from "../assets/project-finGenius-ai/img2.png";
import img3FinGenius from "../assets/project-finGenius-ai/img3.png";
import img4FinGenius from "../assets/project-finGenius-ai/img4.png";
import img5FinGenius from "../assets/project-finGenius-ai/img5.png";
import img6FinGenius from "../assets/project-finGenius-ai/img6.png";
/************************ Project - Parse Engine */
import img1ParseEngine from "../assets/project-parse-engine/img-1.png";
import img2ParseEngine from "../assets/project-parse-engine/img-2.png";
import img3ParseEngine from "../assets/project-parse-engine/img-3.png";
import { TechSkills } from "./all-skills-data";

export const projectsData = [
  {
    title: "Parse Engine",
    italicsTitle: "Local-First AI Data Extraction Application",
    tags: ["Full-stack", "AI", "Ollama", "SSE"],
    images: [
      { url: img1ParseEngine, alt: "Parse Engine extraction job dashboard" },
      {
        type: "youtube",
        url: "https://www.youtube.com/embed/skuWK90L794?rel=0&iv_load_policy=3&playsinline=1",
        alt: "Parse Engine demo video",
      },
      { url: img2ParseEngine, alt: "Parse Engine dataset upload workflow" },
      { url: img3ParseEngine, alt: "Parse Engine output schema builder" },
    ],
    description: (
      <>
        <p>
          Parse Engine is a local-first web application for extracting
          structured data from raw text using locally served LLMs. It provides a
          complete workflow for organizing source data, defining reusable
          extraction instructions, running batch jobs, reviewing results, and
          exporting structured JSON.
        </p>
        <div>
          <h3>Key Features:</h3>
          <p>
            • Dataset workflows with manual entry, file upload, and API ingestion
          </p>
          <p>
            • Reusable prompt templates with optional structured output schemas
          </p>
          <p>• Local Ollama model discovery with configurable model options</p>
          <p>
            • Batch extraction jobs with stop, resume, and retry workflows
          </p>
          <p>• Live progress updates powered by Server-Sent Events</p>
          <p>• Result audit trail, faceted filtering, and JSON export</p>
        </div>
      </>
    ),
    techSkills: [
      TechSkills.NextJS,
      TechSkills.TypeScript,
      TechSkills.React,
      TechSkills.ReactQuery,
      TechSkills.TailwindCSS,
      TechSkills.Prisma,
      TechSkills.SQLite,
      TechSkills.NodeJS,
    ],
    codeSource: "https://github.com/tareq-hrh/parse_engine",
    demoVideo: "https://www.youtube.com/watch?v=skuWK90L794",
  },
  {
    title: "FinGenius AI",
    italicsTitle: "AI-Powered Financial Management Application",
    tags: ["Full-stack", "Gemini AI"],
    images: [
      { url: img1FinGenius, alt: "FinGenius/img1" },
      { url: img2FinGenius, alt: "FinGenius/img2" },
      { url: img3FinGenius, alt: "FinGenius/img3" },
      { url: img4FinGenius, alt: "FinGenius/img4" },
      { url: img5FinGenius, alt: "FinGenius/img5" },
      { url: img6FinGenius, alt: "FinGenius/img6" },
    ],
    description: (
      <>
        <p>
          FinGenius AI combines personal finance management with AI-assisted
          receipt processing and financial analysis. It generates financial
          health scores, cash-flow insights, and budgeting recommendations from
          transaction data.
        </p>
        <div>
          <h3>Key Features:</h3>
          <p>• AI-driven receipt scanning using Google Generative AI</p>
          <p>• Receive personalized health scores based on transaction data</p>
          <p>• Forecast monthly trends and get tailored budgeting advice</p>
          <p>• Modern responsive UI built with Next.js and Tailwind CSS</p>
          <p>• Scalable backend with Node.js, PostgreSQL, and AWS</p>
        </div>
      </>
    ),
    techSkills: [
      TechSkills.NextJS,
      TechSkills.PostgreSQL,
      TechSkills.NodeJS,
      TechSkills.TailwindCSS,
      TechSkills.Prisma,
      TechSkills.ExpressJS,
      TechSkills.AWS,
    ],
    codeSource: "https://github.com/tareq-hrh/DemoAiFinancialApplication",
  },
  {
    title: "MediCopter",
    italicsTitle: "Autonomous Healthcare Delivery System",
    tags: ["Full-stack", "MAVLink", "WebSocket"],
    images: [
      { url: img1Medicopter, alt: "medicopter/img1" },
      { url: img2Medicopter, alt: "medicopter/img2" },
      { url: img3Medicopter, alt: "medicopter/img3" },
      { url: img4Medicopter, alt: "medicopter/img4" },
      { url: img5Medicopter, alt: "medicopter/img5" },
      { url: img6Medicopter, alt: "medicopter/img6" },
      { url: img7Medicopter, alt: "medicopter/img7" },
    ],
    description: (
      <>
        <p>
          MediCopter is a healthcare delivery platform for autonomous unmanned
          aerial vehicle (UAV) operations. Developed as a graduation project, it
          combined a delivery quadcopter with a web-based ordering and
          ground-control application.
        </p>
        <div>
          <h3>Key Features:</h3>
          <p>• Autonomous UAV healthcare delivery</p>
          <p>• Web-based ground control station for UAV operations</p>
          <p>• Real-time drone communication workflows</p>
          <p>• MAVLink and WebSocket integration</p>
          <p>• End-to-end autonomous medicine delivery workflow</p>
          <p>
            • Medicine ordering platform for healthcare delivery stakeholders
          </p>
        </div>
      </>
    ),
    techSkills: [
      TechSkills.Python,
      TechSkills.React,
      TechSkills.MongoDB,
      TechSkills.Bootstrap,
      TechSkills.Flask,
    ],
  },
  {
    title: "FikrTeam",
    italicsTitle: "Educational Services Platform",
    tags: ["Freelance", "Full-stack"],
    images: [
      { url: img1FikrTeam, alt: "FikrTeam/img1" },
      { url: img2FikrTeam, alt: "FikrTeam/img2" },
      { url: img3FikrTeam, alt: "FikrTeam/img3" },
      { url: img4FikrTeam, alt: "FikrTeam/img4" },
    ],
    description: (
      <>
        <p>
          FikrTeam is an educational services platform that helps international
          students apply to universities in Türkiye. I worked closely with the
          client to build a full-stack solution tailored to their operational
          needs.
        </p>
        <div>
          <h3>Key Features:</h3>
          <p>• Designed and implemented a modern user interface</p>
          <p>• Developed server-rendered pages for public content</p>
          <p>
            • Built backend and database functionality with Node.js, Pug.js, and
            MongoDB
          </p>
          <p>• Collaborated directly with the client to define requirements</p>
        </div>
      </>
    ),
    techSkills: [
      TechSkills.NodeJS,
      TechSkills.PugJS,
      TechSkills.MongoDB,
      TechSkills.Bootstrap,
      TechSkills.CSS,
    ],
  },
];
